'use client';
import React, { useState } from 'react';

interface EditTextProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  disabled?: boolean;
  required?: boolean;
  className?: string;
  name?: string;
  id?: string;
  autoComplete?: string;
  maxLength?: number;
  minLength?: number;
}

const EditText: React.FC<EditTextProps & React.InputHTMLAttributes<HTMLInputElement>> = ({
  placeholder = '',
  value,
  onChange,
  type = 'text',
  disabled = false,
  required = false,
  className = '',
  name,
  id,
  autoComplete,
  maxLength,
  minLength,
  ...props
}) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div data-component-id="src/components/ui/EditText.tsx:54:4" data-component-path="src/components/ui/EditText.tsx" data-component-line="54" data-component-file="EditText.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
      <input data-component-id="src/components/ui/EditText.tsx:55:6" data-component-path="src/components/ui/EditText.tsx" data-component-line="55" data-component-file="EditText.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22id%22%3A%22%5Bvar%3Aid%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        type={type}
        value={value !== undefined ? value : internalValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        name={name}
        id={id}
        autoComplete={autoComplete}
        maxLength={maxLength}
        minLength={minLength}
        className={`
          w-full
          bg-edittext-1
          text-edittext-1
          text-[16px] font-inter font-normal leading-[20px] text-left
          pt-[8px] pr-[16px] pb-[8px] pl-[16px]
          rounded-[6px]
          border-0
          focus:outline-none
          focus:ring-2
          focus:ring-global-1
          focus:ring-opacity-50
          placeholder:text-edittext-1
          placeholder:opacity-70
          transition-all
          duration-200
          ease-in-out
          ${isFocused ? 'ring-2 ring-global-1 ring-opacity-50' : ''}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-text'}
          min-h-[44px] sm:min-h-[48px]
          touch-manipulation
          ${className}
        `.trim().replace(/\s+/g, ' ')}
        {...props}
      />
    </div>
  );
};

export default EditText;